import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl, defineMessages } from 'react-intl'
import { Button } from '../components'

import './BottomSave.scss'

const BottomSave = ({ onClick, intl, text }) => (
  <div className="bottom-save">
    <p>{text}</p>
    <Button positive big onClick={onClick}>
      Save
    </Button>
  </div>
)

BottomSave.defaultProps = {
  text: '',
}

BottomSave.propTypes = {
  onClick: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
  text: PropTypes.string,
}

export default injectIntl(BottomSave)

/*
const messages = defineMessages({
  saveLabel: {
    id: 'saveBottom.label',
    defaultMessage: 'Save',
  },
})
*/


// WEBPACK FOOTER //
// ./src/browser/components/BottomSave.js